import { useQuery } from '@tanstack/react-query'

import { TScreening } from '../model/types'

import { fetchScreeningResult, rerunScreening } from './competitorBadActorReviewApi'
import { competitorBadActorReviewKeys } from './queryKeys'

export function useScreeningResult(requestId: number, screening: TScreening) {
  return useQuery({
    queryKey: competitorBadActorReviewKeys.result(requestId, screening),
    queryFn: () => fetchScreeningResult(requestId, screening),
  })
}

export function useScreeningRerun(requestId: number, screening: TScreening, run: number) {
  return useQuery({
    queryKey: competitorBadActorReviewKeys.rerun(requestId, screening, run),
    queryFn: () => rerunScreening(requestId, screening),
    gcTime: 0,
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
